import {registerReactPartial} from '@github-ui/react-core/register-partial'
import {MarketingNavigation} from './MarketingNavigation'

registerReactPartial('marketing-navigation', {
  Component: MarketingNavigation,
})
